import * as types from "../actions/types";
import {actionTypes} from "./reducerTypes";
let initialState = {
    leadUID: "",
    leadAssignedAgent: {},
    leadDetails: {domainName: ""},
    myLeadList: [],
    newDomainName: "",
    newOfferAmount: "",
    contactUsDomainName: "",
    lowBudgetWindow: {}
}

const leadReducer = (state = initialState, action: actionTypes) => {
    switch (action.type) {
        case types.LOW_BUDGET_WINDOW:
            return {
                ...state, lowBudgetWindow: action.payload
            }
        case types.SET_CONTACT_US_DOMAIN:
            return {
                ...state, contactUsDomainName: action.payload
            }
        case types.SET_DOMAIN_NAME:
            return {
                ...state, newDomainName: action.payload
            }
        case types.SET_DOMAIN_OFFER_AMOUNT:
            return {
                ...state, newOfferAmount: action.payload
            }

        case types.GET_MY_LEADS:
            let leadAssignedAgent = {}
            if (action.payload.length >= 0) {
                leadAssignedAgent = action.payload[0]?.consultant
            }
            let leadDetails = state.leadDetails || {}
            if (leadDetails.domainName === "" && action.payload.length > 0) {
                leadDetails = action.payload[0]
            }
            return {
                ...state, leadDetails, leadAssignedAgent, myLeadList: action.payload
            }
        case types.LEAD_DETAILS:
            return {
                ...state,
                leadDetails: action.payload
            };

        case types.LEAD_UID:
            return {
                ...state,
                leadUID: action.payload
            };
        case types.LEAD_ASSIGNED_AGENT:
            return {
                ...state,
                leadAssignedAgent: action.payload
            };
        default:
            return state;
    }
};

export default leadReducer

